// This map is based on https://github.com/goatapp/go-services/blob/master/consumer-search/constructor-sync/resources/item_groups.csv#L78
// Updates to this file are rare, but BE should coordinate with us and we will have to update this list

export const PRODUCT_TYPES = {
  accessories: new Set([
    'belts',
    'eyewear',
    'gloves',
    'hats',
    'keychains',
    'masks',
    'miscellaneous',
    'other',
    'phone_cases',
    'scarves',
    'socks',
    'technology',
    'umbrellas',
    'wallets',
  ]),
  all: new Set([
    'accessories',
    'apparel',
    'art',
    'bags',
    'collectibles',
    'jewelry',
    'sneakers',
    'space',
  ]),
  apparel: new Set(['bottoms', 'dresses', 'outerwear', 'swimwear', 'tops']),
  art: new Set(['prints', 'photography']),
  bags: new Set([
    'backpacks',
    'briefcases',
    'clutches',
    'duffles',
    'luggage',
    'messengers_and_satchels',
    'pouches',
    'shoulder_bags',
    'top_handle',
    'tote_bags',
    'travel_bags',
  ]),
  bottoms: new Set([
    'jeans',
    'jumpsuits',
    'leggings',
    'shorts',
    'skirts',
    'sweatpants',
    'trousers',
  ]),
  collectibles: new Set(['comics', 'skate_decks', 'toys']),
  dresses: new Set(['long', 'mid_length', 'short']),
  eyewear: new Set(['goggles', 'sunglasses']),
  hats: new Set(['beanies', 'caps']),
  jewelry: new Set(['bracelets', 'earrings', 'necklaces', 'pins', 'rings', 'watches']),
  outerwear: new Set([
    'blazers',
    'bombers',
    'coats',
    'down',
    'capes',
    'denim_jackets',
    'jackets',
    'leather_jackets',
    'parkas',
    'trench_coats',
    'vests',
  ]),
  sneakers: new Set([
    'basketball',
    'boots',
    'cleats',
    'lifestyle',
    'running',
    'sandals',
    'skateboarding',
  ]),
  space: new Set(['books', 'magazines', 'music', 'object', 'furniture']),
  swimwear: new Set(['bikinis', 'one_piece', 'swim_shorts']),
  t_shirts: new Set(['long_sleeve_t_shirt', 'short_sleeve_t_shirt']),
  tops: new Set([
    'blouses',
    'cardigans',
    'crewnecks',
    'hoodies',
    'jerseys',
    'polos',
    'shirts',
    'sports_bras',
    'sweaters',
    'sweatshirts',
    't_shirts',
    'tanks',
    'turtleneck',
  ]),
  wallets: new Set(['cardholders', 'coin_pouches']),
};
